<div mat-dialog-title>
  <div class="df jsb ac f1">
    <h1>
      <T
        *ngIf="data?.caseId"
        str="Merge into {caseId} - {caseName}"
        [vars]="{ caseId: data?.caseId ?? -2, caseName: data?.caseName ?? 'Unknown' }"></T>

      <T
        *ngIf="!data?.caseId"
        str="Merge into new case"></T>
    </h1>
    <button
      mat-icon-button
      (click)="close()"
      tabindex="-1">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>
<div
  mat-dialog-content
  class="df oh rpi">
  <div class="df c f1">
    <div class="">
      <div class="df r ap rpb">
        <mat-form-field class="full-width f1 amr">
          <mat-label>
            <T str="Search"></T>
          </mat-label>
          <input
            #search
            autofocus="true"
            type="text"
            [ngModel]="searchText"
            [placeholder]="'Search' | translate"
            aria-label="Number"
            (ngModelChange)="debouncedSearchChange($event, false)"
            matInput />
        </mat-form-field>

        <ng-container *ngIf="data?.ProjectId">
          <apex-autocomplete
            [disabled]="true"
            type="Project"
            [(ngModel)]="data.ProjectId"
            [label]="'Project' | translate">
          </apex-autocomplete>
          <apex-autocomplete
            type="Apartment"
            [(ngModel)]="data.ApartmentId"
            (ngModelChange)="debouncedSearchChange(search.value, true)"
            [label]="'Apartment' | translate"
            [params]="{ ProjectId: data.ProjectId }">
          </apex-autocomplete>
        </ng-container>
        <ng-container *ngIf="data?.ObjectId">
          <apex-autocomplete
            [disabled]="true"
            type="Object"
            [(ngModel)]="data.ObjectId"
            [label]="'Object' | translate">
          </apex-autocomplete>
        </ng-container>
      </div>
    </div>

    <div class="f1 df c scrollable max-height-100">
      <div
        class="f1 df c ac jc"
        *ngIf="loading">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
      <div
        class="f1 df c scrollable max-height-100"
        *ngIf="!loading">
        @for (c of cases; track c) {
          <div class="df r">
            <apex-merged-cases-list-item
              class="db f1"
              [mergedCase]="c"></apex-merged-cases-list-item>
            <div class="ap">
              <mat-checkbox
                [checked]="selectionList.isSelected(c)"
                (click)="selectionList.toggle(c)"></mat-checkbox>
            </div>
          </div>
          <mat-divider class="amb"></mat-divider>
        }
      </div>
    </div>

    <div>
      <apex-box
        [expandable]="true"
        [expanded]="false">
        <T
          title
          str="{count} selected cases"
          [vars]="{ count: selectionList.selected.length }"></T>

        <p
          class="rp rm"
          *ngIf="!selectionList.selected.length">
          <T str="No cases selected"></T>
        </p>

        <div
          class="f1 df c scrollable"
          style="height: 256px; max-height: 256px">
          <mat-list>
            @for (c of selectionList.selected; track c) {
              <mat-list-item>
                <span matListItemTitle>
                  <ng-container *ngIf="c.EntryCardId || c.fromProjectMom; else normalTitle">
                    <T
                      *ngIf="c.EntryCardId"
                      str="Entry card request"></T>
                    <T
                      *ngIf="c.fromProjectMom"
                      str="MOM for {fieldName}"
                      [vars]="{ fieldName: c.Field?.name ?? '' }"></T>
                  </ng-container>
                  <ng-template #normalTitle>{{ c.name }}</ng-template>
                </span>
                <span matListItemLine>{{ c.id }}</span>
                <span
                  matListItemLine
                  *ngIf="c.CaseCategory?.name"
                  >{{ c.CaseCategory.name | translate }}
                </span>
                <span matListItemMeta>
                  <mat-checkbox
                    [checked]="selectionList.isSelected(c)"
                    (click)="selectionList.toggle(c)"></mat-checkbox>
                </span>
              </mat-list-item>
            }
          </mat-list>
        </div>
      </apex-box>
      <div>
        <mat-checkbox
          [(ngModel)]="mergeDescriptions"
          class="amr">
          <T
            str="Merge descriptions into {caseName}"
            [vars]="{ caseName: data.caseName ?? ('New case' | translate) }"></T>
        </mat-checkbox>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <div></div>
  <div>
    <button
      class="amr"
      mat-button
      type="button"
      (click)="close()">
      <T str="Cancel"></T>
    </button>

    <button
      color="primary"
      class="amr"
      mat-raised-button
      type="button"
      [disabled]="loading || !selectionList.selected.length"
      (click)="merge()">
      <T str="Merge"></T>
    </button>
  </div>
</div>
